#
# Entfernen von Favoriten aus einer Favoriten-Auflistung
#
$("ul.favorites").on 'ajax:success', 'a[data-method=delete]', ->
  $this = $(this)
  $this.closest("ul").trigger('updated')
  $this.closest("li").remove()
